export const RESET = 'EXSBPRICEITEM_LIST_RESET'
export const SET_ITEMS = 'EXSBPRICEITEM_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBPRICEITEM_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBPRICEITEM_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBPRICEITEM_LIST_TOGGLE_LOADING'
